import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import CustomTimePicker from '@/app/customComponents/CustomTimePicker/CustomTimePicker';
import { getAllRooms, getRooms } from '@/app/services/rooms/rooms';
import { getStaff } from '@/app/services/staff/staff';
import { deleteEvent, updateWorkshift } from '@/app/services/staff/staffschedule';
import * as Actions from '@/app/store/actions';
import { scrollIntoView } from '@/utils/utils';
import {
	Avatar,
	Checkbox,
	Chip,
	CircularProgress,
	FormControlLabel,
	IconButton,
	TextField,
	Typography,
} from '@material-ui/core';

import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import Autocomplete from '@material-ui/lab/Autocomplete';
import dayjs from 'dayjs';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './calendar.css';
import { useNavigate, useLocation } from 'react-router-dom';

const EditWorkShiftSchedule = () => {
	const location = useLocation();
	const { state } = location;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [repeatEveryWeek, setRepeat] = useState(true);
	const [form, setForm] = useState({});
	const [errTxts, setErrTxts] = useState({});
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [date, setDate] = useState();
	const [staff, setStaff] = useState([]);
	const [searchStaffQuery, setSearchStaffQuery] = useState('');
	const [rooms, setRooms] = useState([]);
	const [searchRoomQuery, setRoomSearchQuery] = useState('');
	const [isStaffLoading, setIsStaffLoading] = useState(false);
	const [isRoomLoading, setIsRoomLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [defaultStaff, setDefaultStaff] = useState({});
	const [activeDay, setActiveDay] = useState(null);
	const [scheduleid, setScheduleid] = useState();
	const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	const [repeatTime, setRepeatTime] = useState(state.repeat_time || false);
	const [days, setDays] = useState(state.repeat_time ? state.shifts.map((shift) => shift.day.toLowerCase()) : []);
	const dayNum = {
		monday: 0,
		tuesday: 1,
		wednesday: 2,
		thursday: 3,
		friday: 4,
		saturday: 5,
		sunday: 6,
	};
	const [singleDayShifts, setSingleDayShifts] = useState(1);
	const [multiDayShifts, setMultiDayShifts] = useState(Array(7).fill(1));
	const [singleShifts, setSingleShifts] = useState([{ start_time: '06:00', end_time: '19:00' }]);
	const [multiShifts, setMultiShifts] = useState({
		monday: [{ start_time: '06:00', end_time: '19:00' }],
		tuesday: [{ start_time: '06:00', end_time: '19:00' }],
		wednesday: [{ start_time: '06:00', end_time: '19:00' }],
		thursday: [{ start_time: '06:00', end_time: '19:00' }],
		friday: [{ start_time: '06:00', end_time: '19:00' }],
		saturday: [{ start_time: '06:00', end_time: '19:00' }],
		sunday: [{ start_time: '06:00', end_time: '19:00' }],
	});
	const returnDateFromTime = (time) => {
		if (time) {
			return new Date('', '', '', time.split(':')[0], time.split(':')[1], '', '');
		}
		return undefined;
	};

	useEffect(() => {
		if (!state.staff) {
			navigate('/staff-schedule');
		}
		console.log(state.staff?.filter((s) => s.id === state.teacher_id)[0]);
		setDefaultStaff(state.staff?.filter((s) => s.id === state.teacher_id)[0]);
		if (!state.recurring || (state.recurring && state.repeat_time)) {
			setSingleShifts(state.shifts?.filter((shift) => shift?.day === (state.shifts && state.shifts[0].day)));
			setSingleDayShifts(state.shifts?.filter((shift) => shift?.day === (state.shifts && state.shifts[0].day)).length);
		} else {
			const ms = {
				...multiShifts,
			};
			state.shifts.forEach((shift) => {
				ms[shift.day].length === 1 && !ms[shift.day][0].room_id && ms[shift.day].pop();
				ms[shift.day].push(shift);
			});
			const mds = [];
			for (const day of Object.keys(ms)) {
				mds[dayNum[day]] = ms[day].length;
			}
			setMultiDayShifts(mds);
		}
		setStartDate(state?.recurring ? state?.schedule_start_date : '');
		setEndDate(state?.recurring ? state?.schedule_end_date : '');
		setDate(!state?.recurring ? state?.start_date : '');

		setForm({
			...form,
			selectedDays: state?.days,
			staff: state?.teacher_id,
			description: state?.description,
			startDate: state?.recurring ? state?.schedule_start_date : '',
			endDate: state?.recurring ? state?.schedule_end_date : '',
			date: !state?.recurring ? state?.start_date : '',
		});
		setRepeat(!!state.recurring);
		setRepeatTime(!!state.repeat_time);
		setScheduleid(state?.id);
	}, []);

	useEffect(() => {
		let isMounted = true;
		setIsStaffLoading(true);
		setStaff([]);
		getStaff(searchStaffQuery, searchStaffQuery ? undefined : 1)
			.then(({ data }) => {
				if (!isMounted) return;
				setStaff(data.data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				if (!isMounted) return;
				setIsStaffLoading(false);
			});

		return () => {
			isMounted = false;
		};
	}, [searchStaffQuery]);

	useEffect(() => {
		let isMounted = true;
		setIsRoomLoading(true);
		setRooms([]);
		if (!searchRoomQuery) {
			getAllRooms()
				.then(({ data }) => {
					if (!isMounted) return;
					setRooms(data);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch data, please refresh',
							variant: 'error',
						})
					);
				})
				.finally(() => {
					if (!isMounted) return;
					setIsRoomLoading(false);
				});
		} else {
			getRooms(searchRoomQuery, searchRoomQuery ? undefined : 1)
				.then(({ data }) => {
					if (!isMounted) return;
					setRooms(data.data);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch data, please refresh',
							variant: 'error',
						})
					);
				})
				.finally(() => {
					if (!isMounted) return;
					setIsRoomLoading(false);
				});
		}
		return () => {
			isMounted = false;
		};
	}, [searchRoomQuery]);

	const handleDaySelection = (day) => {
		setActiveDay(day.toLowerCase());
	};

	const handleDays = (day) => {
		const found = days?.find((d) => d.toLowerCase() === day.toLowerCase());
		if (found) {
			const newDays = days.filter((d) => d.toLowerCase() !== found.toLowerCase());
			console.log(newDays);
			setDays(newDays);
		} else {
			setDays([...days, day]);
		}
	};

	const handleSubmit = () => {
		setErrTxts({});
		let isError = false;
		if (!form.staff) {
			setErrTxts((prev) => ({ ...prev, staff: 'This field is required' }));
			isError = true;
			scrollIntoView('staff');
		}
		if (!repeatEveryWeek) {
			delete form.startDate;
			delete form.endDate;
			setStartDate('');
			setEndDate('');

			if (!form.date) {
				setErrTxts((prev) => ({ ...prev, date: 'This field is required' }));
				isError = true;
				scrollIntoView('staff');
			}

			singleShifts.forEach((shift, index) => {
				if (!shift.start_time) {
					setErrTxts((prev) => ({
						...prev,
						[`start_time-${index}`]: 'This is required',
					}));
					isError = true;
				}
				if (!shift.end_time) {
					setErrTxts((prev) => ({
						...prev,
						[`end_time-${index}`]: 'This is required',
					}));
					isError = true;
				}
				if (shift.start_time > shift.end_time) {
					setErrTxts((prev) => ({
						...prev,
						[`end_time-${index}`]: 'End time must be greater than start time',
					}));
					isError = true;
				}
				if (!shift.room_id) {
					setErrTxts((prev) => ({
						...prev,
						[`room-${index}`]: 'This is required',
					}));
					isError = true;
				}
			});
		}
		if (repeatEveryWeek && !repeatTime) {
			delete form.date;
			setDate('');

			if (!form.startDate) {
				setErrTxts((prev) => ({ ...prev, startDate: 'This field is required' }));
				isError = true;
				scrollIntoView('staff');
			}
			if (!form.endDate) {
				setErrTxts((prev) => ({ ...prev, endDate: 'This field is required' }));
				isError = true;
				scrollIntoView('staff');
			}
			let validCount = 0;
			for (const day of Object.keys(multiShifts)) {
				validCount += multiShifts[day].filter((shift) => shift.start_time && shift.end_time && shift.room_id).length;
			}
			if (validCount === 0) {
				dispatch(
					Actions.showMessage({
						message: 'No schedule is filled completely',
						autoHideDuration: 2000,
						variant: 'error',
					})
				);
				return;
			}
			for (const day of Object.keys(multiShifts)) {
				multiShifts[day].forEach((shift, index, arr) => {
					if (arr.length === 1 && !shift.room_id) {
						// incase of default selection, return and dont check
						return;
					}
					if (!shift.start_time) {
						setErrTxts((prev) => ({
							...prev,
							[`start_time-${day}-${index}`]: 'This is required',
						}));
						isError = true;
					}
					if (!shift.end_time) {
						setErrTxts((prev) => ({
							...prev,
							[`end_time-${day}-${index}`]: 'This is required',
						}));
						isError = true;
					}
					if (shift.start_time > shift.end_time) {
						setErrTxts((prev) => ({
							...prev,
							[`end_time-${day}-${index}`]: 'End time must be greater than start time',
						}));
						isError = true;
					}
					if (!shift.room_id) {
						setErrTxts((prev) => ({
							...prev,
							[`room-${day}-${index}`]: 'This is required',
						}));
						isError = true;
					}
				});
				if (isError) {
					setActiveDay(day);
					return;
				}
			}
			if (isError) {
				return;
			}
		}
		if (repeatEveryWeek && repeatTime) {
			delete form.date;
			setDate('');
			if (!form.startDate) {
				setErrTxts((prev) => ({ ...prev, startDate: 'This field is required' }));
				isError = true;
				scrollIntoView('staff');
			}
			if (!form.endDate) {
				setErrTxts((prev) => ({ ...prev, endDate: 'This field is required' }));
				isError = true;
				scrollIntoView('staff');
			}

			singleShifts.forEach((shift, index) => {
				if (!shift.start_time) {
					setErrTxts((prev) => ({
						...prev,
						[`start_time-${index}`]: 'This is required',
					}));
					isError = true;
				}
				if (!shift.end_time) {
					setErrTxts((prev) => ({
						...prev,
						[`end_time-${index}`]: 'This is required',
					}));
					isError = true;
				}
				if (shift.start_time > shift.end_time) {
					setErrTxts((prev) => ({
						...prev,
						[`end_time-${index}`]: 'End time must be greater than start time',
					}));
					isError = true;
				}
				if (!shift.room_id) {
					setErrTxts((prev) => ({
						...prev,
						[`room-${index}`]: 'This is required',
					}));
					isError = true;
				}
			});
			if (days.length === 0) {
				dispatch(
					Actions.showMessage({
						message: 'Select atleast one day',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
				return;
			}
		}
		if (isError) {
			return;
		}
		const filteredShifts = {};
		if (!repeatTime) {
			for (const day of Object.keys(multiShifts)) {
				filteredShifts[day] = multiShifts[day].filter((shift) => shift.start_time && shift.end_time && shift.room_id);
				console.log(filteredShifts);
				if (filteredShifts[day].length === 0) {
					delete filteredShifts[day];
				}
			}
		} else {
			for (const day of days) {
				filteredShifts[day] = singleShifts;
			}
		}
		console.log(filteredShifts);
		const payload = !repeatEveryWeek
			? {
					teacher_id: form.staff,
					start_date: form.date,
					end_date: form.date,
					single_shift: singleShifts,
					recurring: 0,
					repeat_time: 0,
					description: form.description,
				}
			: {
					teacher_id: form.staff,
					start_date: form.startDate,
					end_date: form.endDate,
					multiple_shifts: filteredShifts,
					recurring: 1,
					repeat_time: repeatTime ? 1 : 0,
					description: form.description,
				};
		setIsLoading(true);
		updateWorkshift(state.id, payload)
			.then((resp) => {
				dispatch(
					Actions.showMessage({
						message: resp.data.message,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				navigate('/staff-schedule');
			})
			.catch((err) => {
				if (err.response?.data?.errors) {
					setErrTxts(err.response.data.errors);
				} else {
					dispatch(
						Actions.showMessage({
							message: err.response.data.message,
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
				}
			})
			.finally(() => setIsLoading(false));
	};

	const handledelete = () => {
		deleteEvent(scheduleid)
			.then((res) => {
				dispatch(
					Actions.showMessage({
						message: res.data.message,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				navigate('/staff-schedule');
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: err.response.data.message,
						variant: 'error',
					})
				);
			});
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn">
			<div className="pl-52 pt-52 pb-52 pr-52">
				<div className="text-pd-lg font-bold" style={{ fontSize: '20px', fontWeight: '700' }}>
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					Edit Staff To Schedules
				</div>
				<div className="bg-white rounded mt-12 mb-72 p-48">
					<div className="flex justify-between items-end">
						<span className="text-pd-lg font-bold" style={{ fontSize: '18px', fontWeight: '700' }}>
							Work Shift
						</span>
						<div className="flex justify-between items-center">
							<IconButton className="py-12 px-24" onClick={() => handledelete()} size="small">
								<div className="flex">
									<img alt="edit" src="assets/images/dlt.png" width="25px" />
									<div
										className="flex justify-between "
										style={{
											marginBottom: '4px',
											marginLeft: '8px',
											fontSize: '14px',
											color: 'red',
											cursor: 'pointer',
										}}
									>
										<span>Delete</span>
									</div>
								</div>
							</IconButton>
						</div>
					</div>

					<div
						className={`grid grid-cols-2 grid-rows-${repeatEveryWeek ? '4' : '3'} mt-32`}
						style={{ gridRowGap: '40px', gridColumnGap: '40px' }}
					>
						<div className="col-span-1 row-span-1">
							<Autocomplete
								autoComplete={false}
								className="w-4/5"
								clearOnBlur={false}
								getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
								id="staff"
								loading={isStaffLoading}
								loadingText="...Loading"
								onChange={(e, v) => {
									setDefaultStaff(v);
									setErrTxts({ ...errTxts, staff: '' });
									setForm({ ...form, staff: v?.id });
								}}
								options={staff}
								renderInput={(params) => (
									<TextField
										{...params}
										autoComplete="off"
										error={errTxts.staff}
										helperText={errTxts.staff}
										label="Staff"
										onChange={(e) => setSearchStaffQuery(e.target.value)}
										style={{ width: '100%' }}
									/>
								)}
								renderOption={(option) => (
									<div className="flex items-center" style={{ gap: 10 }}>
										<Avatar src={option.thumb} />
										<div>
											{option.first_name} {option.last_name}
										</div>
									</div>
								)}
								sx={{ width: '100%' }}
								value={defaultStaff}
							/>
						</div>
						<div className="col-span-1 row-span-1 flex flex-col pr-52 items-end">
							<FormControlLabel
								control={
									<Checkbox
										checked={repeatEveryWeek}
										checkedIcon={<CircleCheckedFilled style={{ color: '#028AFD' }} />}
										className="p-6"
										icon={<CircleUnchecked />}
										name="repeat"
										onChange={() => {
											setRepeat(!repeatEveryWeek);
										}}
										size="medium"
									/>
								}
								label={
									<Typography style={{ color: '#028AFD', fontWeight: 'bold' }} variant="body1">
										Repeats every week
									</Typography>
								}
								styles={{ color: '#4da0ed' }}
							/>
						</div>
						{repeatEveryWeek ? (
							<div className="col-span-2 flex justify-between">
								<div className="flex-grow">
									<CustomDatePicker
										disablePast
										errTxts={errTxts.startDate}
										label="Start Date"
										maxDate={form.endDate || undefined}
										setValue={(value) => {
											setErrTxts({ ...errTxts, startDate: '' });
											const date = value ? dayjs(value).format('YYYY-MM-DD') : '';
											setStartDate(date);
											setForm({ ...form, startDate: date });
										}}
										value={startDate}
										width="81%"
									/>
								</div>
								<div className="pt-32 mr-12">to</div>
								<div className="flex-grow flex justify-end" style={{ marginRight: 40 }}>
									<CustomDatePicker
										disablePast
										errTxts={errTxts.endDate}
										label="End date"
										minDate={form.startDate || undefined}
										setValue={(value) => {
											setErrTxts({ ...errTxts, endDate: '' });
											const date = value ? dayjs(value).format('YYYY-MM-DD') : '';
											setEndDate(date);
											setForm({ ...form, endDate: date });
										}}
										value={endDate}
										width="85%"
									/>
								</div>
							</div>
						) : (
							<div className="col-span-1 row-span-1 w-4/5">
								<CustomDatePicker
									disablePast
									errTxts={errTxts.date}
									label="Date"
									setValue={(value) => {
										setErrTxts({ ...errTxts, date: '' });
										const date = value ? dayjs(value).format('YYYY-MM-DD') : '';
										setDate(date);
										setForm({ ...form, date });
									}}
									value={date}
									width="100"
								/>
							</div>
						)}
						<div className="col-span-2">
							<TextField
								className="w-full"
								label="Add Description"
								name="description"
								onChange={(e) => {
									setForm({ ...form, description: e.target.value });
								}}
							/>
						</div>
						{repeatEveryWeek ? (
							<>
								<div className="col-span-2 grid grid-cols-1 gap-16">
									<span className="text-md font-bold grow row-span-1 col-span-1">Days of the week</span>
									<div className="col-span-1">
										<div className="flex">
											{weekdays.map((day, key) => {
												const currentShift = multiShifts[day.toLowerCase()] || null;
												return (
													<div
														className={`pb-8 ${day.toLowerCase() === activeDay ? 'border-b-2 border-blue' : ''}`}
														key={key}
													>
														<Chip
															clickable
															key={key}
															label={day.slice(0, 3)}
															onClick={() => {
																repeatTime ? handleDays(day) : handleDaySelection(day);
															}}
															size="medium"
															style={{
																background:
																	(!repeatTime &&
																		currentShift.every(
																			(shift) => shift.start_time && shift.end_time && shift.room_id
																		)) ||
																	(repeatTime && days?.find((d) => d.toLowerCase() === day.toLowerCase()))
																		? 'transparent linear-gradient(270deg, #36cee5 0%, #676af6 100%) 0% 0% no-repeat padding-box'
																		: '#EFF7FD',
																padding: '18px',
																color:
																	(!repeatTime &&
																		currentShift.every(
																			(shift) => shift.start_time && shift.end_time && shift.room_id
																		)) ||
																	(repeatTime && days?.find((d) => d.toLowerCase() === day.toLowerCase()))
																		? '#fff'
																		: 'black',
																fontWeight:
																	(!repeatTime &&
																		currentShift.every(
																			(shift) => shift.start_time && shift.end_time && shift.room_id
																		)) ||
																	(repeatTime && days?.find((d) => d.toLowerCase() === day.toLowerCase()))
																		? '900'
																		: 'normal',
																marginRight: '10px',
																width: '100px',
															}}
														/>
													</div>
												);
											})}
											<FormControlLabel
												control={
													<Checkbox
														checked={repeatTime}
														checkedIcon={<CircleCheckedFilled style={{ color: '#028AFD' }} />}
														icon={<CircleUnchecked />}
														name="repeattime"
														onChange={() => {
															setActiveDay(null);
															setDays([]);
															setRepeatTime(!repeatTime);
														}}
														size="small"
													/>
												}
												label={
													<Typography style={{ color: '#028AFD', fontWeight: 'bold' }} variant="body1">
														Repeats time
													</Typography>
												}
												styles={{ color: '#4da0ed' }}
											/>
										</div>
									</div>
								</div>
								{repeatTime || activeDay ? <div /> : null}
							</>
						) : null}
						{(repeatEveryWeek && activeDay) || !repeatEveryWeek || repeatTime ? (
							<>
								{!repeatEveryWeek ? <div /> : null}
								<div className="col-span-1 grid grid-cols-2 items-end">
									<div />
									<CustomButton
										onClick={() => {
											if (repeatEveryWeek && !repeatTime) {
												let updatedArr = [...multiDayShifts];
												updatedArr[dayNum[activeDay.toLowerCase()]] += 1;
												setMultiDayShifts(updatedArr);
												let updatedShifts = { ...multiShifts };
												updatedShifts[activeDay].push({
													start_time: '06:00',
													end_time: '19:00',
												});
												setMultiShifts(updatedShifts);
											} else {
												setSingleDayShifts((prev) => prev + 1);
												setSingleShifts([...singleShifts, { start_time: '06:00', end_time: '19:00' }]);
											}
										}}
										style={{ justifySelf: 'end' }}
									>
										+ Add
									</CustomButton>
								</div>
							</>
						) : null}
						{(repeatEveryWeek && activeDay) || !repeatEveryWeek || repeatTime
							? Array(
									repeatEveryWeek && !repeatTime ? multiDayShifts[dayNum[activeDay?.toLowerCase()]] : singleDayShifts
								)
									.fill(1)
									.map((num, ind) => {
										return (
											<Fragment key={ind}>
												<div className="grid grid-cols-2">
													<CustomTimePicker
														errTxts={errTxts}
														handleTimeChange={(time) => {
															if (!repeatEveryWeek || repeatTime) {
																let updatedArr = [...singleShifts];
																updatedArr[ind] = {
																	...singleShifts[ind],
																	start_time: time,
																};
																setSingleShifts(updatedArr);
															} else {
																let updatedShifts = { ...multiShifts };
																updatedShifts[activeDay][ind] = {
																	...updatedShifts[activeDay][ind],
																	start_time: time,
																};
																setMultiShifts(updatedShifts);
															}
														}}
														label="Start Time"
														name={`start_time-${repeatEveryWeek && !repeatTime ? `${activeDay}-${ind}` : ind}`}
														setValue={() => {}}
														value={
															repeatEveryWeek && !repeatTime
																? returnDateFromTime(
																		multiShifts[activeDay] &&
																			multiShifts[activeDay][ind] &&
																			multiShifts[activeDay][ind].start_time
																	)
																: returnDateFromTime(singleShifts[ind] && singleShifts[ind].start_time)
														}
														width="85%"
													/>
													<CustomTimePicker
														errTxts={errTxts}
														handleTimeChange={(time) => {
															if (!repeatEveryWeek || repeatTime) {
																let updatedArr = [...singleShifts];
																updatedArr[ind] = {
																	...singleShifts[ind],
																	end_time: time,
																};
																setSingleShifts(updatedArr);
															} else {
																let updatedShifts = { ...multiShifts };
																updatedShifts[activeDay][ind] = {
																	...updatedShifts[activeDay][ind],
																	end_time: time,
																};
																setMultiShifts(updatedShifts);
															}
														}}
														label="End Time"
														name={`end_time-${repeatEveryWeek && !repeatTime ? `${activeDay}-${ind}` : ind}`}
														setValue={() => {}}
														value={
															repeatEveryWeek && !repeatTime
																? returnDateFromTime(
																		multiShifts[activeDay] &&
																			multiShifts[activeDay][ind] &&
																			multiShifts[activeDay][ind].end_time
																	)
																: returnDateFromTime(singleShifts[ind] && singleShifts[ind].end_time)
														}
														width="78%"
													/>
												</div>
												<div className="flex items-end gap-16">
													<Autocomplete
														autoComplete={false}
														className="flex-grow"
														clearOnBlur={false}
														getOptionLabel={(option) => option.name}
														getOptionSelected={(option, value) => {
															return option.id === value.id;
														}}
														id={`room-${repeatEveryWeek && !repeatTime ? `${activeDay}-${ind}` : ind}`}
														loading={isRoomLoading}
														loadingText="...Loading"
														onChange={(_e, v) => {
															setErrTxts({ ...errTxts, room: '' });
															if (!repeatEveryWeek || repeatTime) {
																let updatedShifts = [...singleShifts];
																updatedShifts[ind] = {
																	...singleShifts[ind],
																	room_id: v?.id || null,
																};
																setSingleShifts(updatedShifts);
															} else {
																let updatedShifts = { ...multiShifts };
																updatedShifts[activeDay][ind] = {
																	...updatedShifts[activeDay][ind],
																	room_id: v?.id || null,
																};
																setMultiShifts(updatedShifts);
															}
															setRoomSearchQuery('');
														}}
														options={rooms}
														renderInput={(params) => (
															<TextField
																{...params}
																autoComplete="off"
																error={
																	!repeatEveryWeek || repeatTime
																		? errTxts[`room-${ind}`]
																		: errTxts[`room-${activeDay}-${ind}`]
																}
																helperText={
																	!repeatEveryWeek || repeatTime
																		? errTxts[`room-${ind}`]
																		: errTxts[`room-${activeDay}-${ind}`]
																}
																label="Room"
																onChange={(e) => setRoomSearchQuery(e.target.value)}
																style={{ width: '100%' }}
															/>
														)}
														renderOption={(option) => (
															<div className="flex" style={{ gap: 10 }}>
																<Avatar src={option.photo} />
																<div>{option.name}</div>
															</div>
														)}
														sx={{ width: '100%' }}
														value={
															repeatEveryWeek && !repeatTime
																? multiShifts[activeDay] && multiShifts[activeDay][ind]
																	? rooms.find((ro) => ro.id === multiShifts[activeDay][ind]?.room_id) || null
																	: null
																: rooms.find((ro) => ro.id === singleShifts[ind]?.room_id) || null
														}
													/>
													{(repeatEveryWeek && !repeatTime && multiDayShifts[dayNum[activeDay.toLowerCase()]] > 1) ||
													singleDayShifts > 1 ? (
														<button
															className="clear-schedule-btn"
															onClick={() => {
																if (repeatEveryWeek && !repeatTime) {
																	console.log('Changin multi');
																	const updatedArr = [
																		...multiShifts[activeDay].slice(0, ind),
																		...multiShifts[activeDay].slice(ind + 1),
																	];
																	setMultiShifts((prev) => ({
																		...prev,
																		[activeDay]: updatedArr,
																	}));
																	const newArr = [...multiDayShifts];
																	newArr[dayNum[activeDay.toLowerCase()]] -= 1;
																	setMultiDayShifts(newArr);
																} else {
																	const updatedArr = [...singleShifts.slice(0, ind), ...singleShifts.slice(ind + 1)];
																	setSingleShifts(updatedArr);
																	setSingleDayShifts(singleDayShifts - 1);
																}
															}}
															type="button"
														>
															Clear
														</button>
													) : null}
												</div>
											</Fragment>
										);
									})
							: null}
					</div>
					{isLoading ? (
						<div className="flex justify-center my-24">
							<CircularProgress className="mx-auto" />
						</div>
					) : (
						<div className="flex justify-center mb-24" style={{ marginTop: 50 }}>
							<span style={{ marginRight: '5px' }}>
								<CustomButton
									marginRight="11px"
									onClick={() => {
										navigate('/staff-schedule');
									}}
									variant="secondary"
									width={140}
								>
									Cancel
								</CustomButton>

								<CustomButton onClick={handleSubmit} variant="primary" width={140}>
									Save
								</CustomButton>
							</span>
						</div>
					)}
				</div>
			</div>
		</FuseAnimate>
	);
};

export default EditWorkShiftSchedule;
